import { Component, OnInit } from '@angular/core';
import { SharedService } from 'app/shared/services/shared.service';
import { ModalsService } from 'app/shared/services/modals.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@Component({
  selector: 'help-component',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
})
export class HelpComponent implements OnInit {
  public request: any;

  constructor(
    public sharedService: SharedService,
    public modalsService: ModalsService,
    public ga: GoogleAnalyticsService
  ) {
    this.request = {
      name: '',
      email: '',
      company: '',
      priority: '',
      message: '',
    };
  }

  ngOnInit() {}

  fileChange($event: any) {
    this.request.attachments = $event;
  }
}
